import Head from 'next/head';

import { useBrand } from '@src/contexts/brand-context';

import { SEOProps } from './types';

const SEO = ({ title }: SEOProps) => {
  const { brand } = useBrand();

  return (
    <Head>
      <title>{`${brand.name} | ${title}`}</title>
    </Head>
  );
};

export default SEO;
